export default __webpack_public_path__ + "static/media/bat-logo.2224cad9.svg";